<template>
    <div class="personal-info">
        <!-- 个人信息卡片 -->
        <div class="profile-card">
            <div class="profile-header">
                <div class="avatar-section">
                    <div class="avatar-container">
                        <file-upload class="avatar-uploader" action="/image/upload?thumbSize=20" :isPermanent="true"
                            :showLoading="true" :maxSize="maxSize" @success="onUploadSuccess"
                            :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
                            <head-image class="avatar" :size="60" :url="userInfo.headImageThumb" radius="50%"
                                :name="userInfo.nickName || userInfo.userName">
                            </head-image>
                        </file-upload>
                        <!-- 悬浮提示涂层 -->
                        <div class="upload-overlay">
                            <i class="el-icon-camera"></i>
                            <span>更换头像</span>
                        </div>
                    </div>
                </div>
                <div class="user-basic-info">
                    <h3 class="user-name">
                        {{ userInfo.nickName || userInfo.userName || '未设置昵称' }}
                        <span class="company-tag" v-if="userInfo.companyName">@{{ userInfo.companyName }}</span>
                    </h3>
                    <p class="user-id">ID: {{ userInfo.userName || '未知用户' }}</p>
                </div>
            </div>
        </div>

        <!-- 详细信息表单 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-user"></i>
                基本信息
            </h4>
            <el-form :model="userInfo" label-width="80px" :rules="rules" ref="personalForm" size="small">
                <el-form-item label="企业" v-if="userInfo.companyName">
                    <span class="company-text">{{ userInfo.companyName }}</span>
                </el-form-item>
                <el-form-item prop="nickName" label="昵称">
                    <el-input v-model="userInfo.nickName" autocomplete="off" size="small" maxlength="32" show-word-limit
                        placeholder="请输入昵称"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                    <el-radio-group v-model="userInfo.sex">
                        <el-radio :label="0">
                            <i class="el-icon-male"></i>
                            男
                        </el-radio>
                        <el-radio :label="1">
                            <i class="el-icon-female"></i>
                            女
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>

        <!-- 联系方式 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-phone"></i>
                联系方式
            </h4>
            <div class="contact-items">
                <div class="contact-item">
                    <div class="contact-label">
                        <i class="el-icon-mobile-phone"></i>
                        <span>手机号</span>
                    </div>
                    <div class="contact-content">
                        <el-input v-if="userInfo.phone" disabled v-model="userInfo.phone" autocomplete="off"
                            size="small"></el-input>
                        <div v-else class="bind-section">
                            <span class="no-bind-text">未绑定手机号</span>
                            <div type="text" @click="onBindPhone" class="bind-btn">
                                <i class="el-icon-link"></i>
                                去绑定
                            </div>
                        </div>
                    </div>
                </div>

                <div class="contact-item">
                    <div class="contact-label">
                        <i class="el-icon-message"></i>
                        <span>邮箱</span>
                    </div>
                    <div class="contact-content">
                        <el-input v-if="userInfo.email" disabled v-model="userInfo.email" autocomplete="off"
                            size="small"></el-input>
                        <div v-else class="bind-section">
                            <span class="no-bind-text">未绑定邮箱</span>
                            <div type="text" @click="onBindEmail" class="bind-btn">
                                <i class="el-icon-link"></i>
                                去绑定
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 个性签名 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-edit"></i>
                个性签名
            </h4>
            <el-form :model="userInfo" ref="personalForm" size="small">
                <el-form-item>
                    <el-input type="textarea" v-model="userInfo.signature" :rows="3" maxlength="64" show-word-limit
                        placeholder="分享你的心情和想法..."></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="btn-group">
            <el-button type="primary" @click="onSubmit()">提 交</el-button>
        </div>
    </div>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";
import HeadImage from "../common/HeadImage.vue";
export default {
    name: "personalInfo",
    components: {
        FileUpload,
        HeadImage
    },
    data() {
        return {
            userInfo: {},
            maxSize: 5 * 1024 * 1024,
            action: "/image/upload",
            rules: {
                nickName: [{
                    required: true,
                    message: '请输入昵称',
                    trigger: 'blur'
                }]
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let mine = this.userStore.userInfo;
            if (!mine || !mine.id) {
                // 防止当前页面原地刷新，没来得及加载用户信息
                setTimeout(() => this.init(), 100)
            } else {
                this.userInfo = JSON.parse(JSON.stringify(mine));
            }
        },
        onSubmit() {
            this.$refs.personalForm.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.$http({
                    url: "/user/update",
                    method: "put",
                    data: this.userInfo
                }).then(() => {
                    this.userStore.loadUser();
                    this.$message.success("修改成功");
                })
            });
        },
        onUploadSuccess(data) {
            this.userInfo.headImage = data.originUrl;
            this.userInfo.headImageThumb = data.thumbUrl;
            // 更新 userStore 中的用户信息
            this.userStore.userInfo.headImage = data.originUrl;
            this.userStore.userInfo.headImageThumb = data.thumbUrl;
        },
        onBindPhone() {
            // 跳转到绑定手机tab页
            this.$emit('switch-tab', '2');
        },
        onBindEmail() {
            // 跳转到绑定邮箱tab页
            this.$emit('switch-tab', '3');
        }
    }

}
</script>

<style lang="scss" scoped>
.personal-info {
    padding: 18px 20px 24px;
    background: transparent; // 透出 dawn 底纸
    min-height: 400px;

    // 个人信息卡片 (glass-l2 + Aurora 顶饰)
    .profile-card {
        position: relative;
        background: rgba(255, 252, 243, 0.78);
        backdrop-filter: blur(40px) saturate(160%);
        -webkit-backdrop-filter: blur(40px) saturate(160%);
        border: 0.5px solid rgba(255, 255, 255, 0.55);
        border-radius: var(--radius-lg);
        padding: 22px 26px;
        margin-bottom: 16px;
        color: var(--im-text-color);
        box-shadow:
            inset 0 1px 0 0 rgba(255, 255, 255, 0.9),
            0 4px 12px rgba(31, 31, 35, 0.04),
            0 12px 32px rgba(31, 31, 35, 0.08);
        overflow: hidden;

        // 顶部 Aurora 装饰条
        &::before {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0;
            height: 2px;
            background: linear-gradient(90deg,
                var(--aurora-blue) 0%,
                var(--aurora-purple) 35%,
                var(--aurora-pink) 65%,
                var(--aurora-gold) 100%);
            opacity: 0.7;
        }

        .profile-header {
            display: flex;
            align-items: center;
            gap: 24px;

            .avatar-section {
                .avatar-container {
                    position: relative;
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    padding: 2px;
                    background: conic-gradient(from 0deg,
                        var(--aurora-blue),
                        var(--aurora-purple),
                        var(--aurora-pink),
                        var(--aurora-gold),
                        var(--aurora-platinum),
                        var(--aurora-blue));
                    box-shadow:
                        0 4px 14px rgba(91, 141, 238, 0.28),
                        0 0 24px rgba(168, 139, 255, 0.18);
                    transition: all 0.3s ease;

                    &:hover { transform: scale(1.04); }

                    .avatar-uploader {
                        --width: 60px;

                        :deep(.el-upload) {
                            border: none !important;
                            border-radius: 50%;
                            cursor: pointer;
                            position: relative;
                            overflow: hidden;
                            transition: all 0.3s ease;
                            width: var(--width);
                            height: var(--width);
                            background: #fff;
                        }

                        :deep(.avatar) {
                            width: var(--width);
                            height: var(--width);
                            display: block;
                            border-radius: 50%;
                            border: 1.5px solid rgba(255, 255, 255, 0.9);
                        }
                    }

                    // 悬浮提示涂层
                    .upload-overlay {
                        position: absolute;
                        top: 2px; left: 2px;
                        width: 60px;
                        height: 60px;
                        background: linear-gradient(135deg, rgba(91, 141, 238, 0.65), rgba(168, 139, 255, 0.65));
                        border-radius: 50%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        font-size: 11px;
                        font-weight: 500;
                        letter-spacing: -0.1px;
                        opacity: 0;
                        transition: opacity 0.3s ease;
                        pointer-events: none;
                        z-index: 10;

                        i {
                            font-size: 18px;
                            margin-bottom: 2px;
                        }
                    }

                    &:hover .upload-overlay {
                        opacity: 1;
                    }
                }
            }

            .user-basic-info {
                flex: 1;
                text-align: left;

                .user-name {
                    margin: 0 0 6px 0;
                    font-size: 22px;
                    font-weight: 700;
                    letter-spacing: -0.4px;
                    color: var(--im-text-color);
                }

                .user-id {
                    margin: 0;
                    font-size: 13px;
                    color: var(--im-text-color-lighter);
                    font-family: 'SF Mono', 'Monaco', 'Menlo', 'Courier New', monospace;
                    letter-spacing: -0.1px;
                }
            }
        }
    }

    // 表单区域 (glass-l1)
    .form-section {
        background: rgba(255, 252, 243, 0.62);
        backdrop-filter: blur(24px) saturate(140%);
        -webkit-backdrop-filter: blur(24px) saturate(140%);
        border: 0.5px solid var(--glass-border);
        border-radius: var(--radius-md);
        padding: 16px 18px;
        margin-bottom: 14px;
        box-shadow:
            inset 0 1px 0 0 var(--glass-border-inner),
            0 1px 2px rgba(31, 31, 35, 0.04),
            0 8px 24px rgba(31, 31, 35, 0.06);

        .section-title {
            margin: 0 0 14px 0;
            font-size: 15px;
            font-weight: 600;
            letter-spacing: -0.3px;
            color: var(--im-text-color);
            display: flex;
            align-items: center;
            gap: 8px;
            padding-bottom: 10px;
            border-bottom: 0.5px solid var(--hairline-soft);

            i {
                color: var(--aurora-blue);
                font-size: 16px;
                background: linear-gradient(135deg, rgba(91, 141, 238, 0.14), rgba(168, 139, 255, 0.10));
                width: 26px; height: 26px;
                border-radius: 8px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
        }

        .company-text {
            font-size: var(--im-font-size);
            color: var(--aurora-gold);
            font-weight: 500;
        }
    }

    // 联系方式区域
    .contact-items {
        .contact-item {
            display: flex;
            align-items: center;
            padding: 12px 0;
            border-bottom: 0.5px solid var(--hairline-soft);

            &:last-child { border-bottom: none; }

            .contact-label {
                display: flex;
                align-items: center;
                gap: 8px;
                width: 110px;
                font-weight: 500;
                font-size: var(--im-font-size);
                color: var(--im-text-color);

                i {
                    color: var(--aurora-blue);
                    font-size: 16px;
                }
            }

            .contact-content {
                flex: 1;

                .bind-section {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .no-bind-text {
                        color: var(--im-text-color-lighter);
                        font-size: var(--im-font-size);
                    }

                    .bind-btn {
                        color: #fff;
                        background: linear-gradient(135deg, var(--aurora-blue), var(--aurora-purple));
                        padding: 6px 14px;
                        border-radius: 999px;
                        font-size: 12px;
                        font-weight: 600;
                        letter-spacing: -0.1px;
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        cursor: pointer;
                        transition: all 0.18s cubic-bezier(0.32, 0.72, 0, 1);
                        box-shadow: 0 2px 8px rgba(91, 141, 238, 0.28);

                        &:hover {
                            transform: translateY(-1px);
                            box-shadow: 0 6px 16px rgba(91, 141, 238, 0.40);
                        }

                        &:active { transform: scale(0.98); }

                        i { font-size: 12px; }
                    }
                }
            }
        }
    }

    // 按钮组
    .btn-group {
        margin-top: 20px;
        display: flex;
        justify-content: center;

        .el-button {
            padding: 10px 36px;
            font-size: 14px;
            font-weight: 600;
            min-width: 160px;
        }
    }
}
</style>
